import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../web/components-v2/Theme/theme';
import { darkGrayFontColor, titles } from '../../../web/styles/colors';

const { colors, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	dateButtonGroup: {
		width: 'inherit',
	},
	dateButton: {
		justifyContent: 'space-between',
		color: darkGrayFontColor,
		':hover': {
			color: darkGrayFontColor,
		},
		flex: 1,
	},
	dateButtonActive: {
		color: titles,
		':hover': {
			color: titles,
		},
	},
	clearFiltersButton: {
		alignSelf: 'flex-end',
	},
	filter: {
		marginBottom: spacing.md + spacing.xs,
		display: 'grid',
		gap: spacing.sm,
		gridTemplateColumns: 'repeat(auto-fill, minmax(min(272px, 100%), 1fr))',
	},
	filterGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.xs,
	},
	label: {
		fontSize: typography.fontSizes.xs,
		fontWeight: typography.fontWeights.bold,
	},
	tabsContainer: {
		display: 'flex',
		borderBottom: `1px solid ${colors.border.main}`,
		marginBottom: spacing.md + spacing.xs,
	},
	tab: {
		borderBottom: '3px solid transparent',
		cursor: 'pointer',
		padding: `${spacing.sm}px ${spacing.md}px`,
		fontSize: typography.fontSizes.sm,
		fontWeight: 500,
	},
	tabActive: {
		borderBottomColor: colors.secondary.main,
	},
	pageRoot: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	pageContent: {
		width: '100%',
		minHeight: 0,
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		borderTopLeftRadius: 16,
	},
	// Layout styles for full-page scrolling (replacing LeadViewRowElement styles)
	demoPerformDateColumn: {
		minWidth: 200,
	},
	lastCallColumn: {
		minWidth: 200,
	},
	// Override for DataboardBody: the page scrolls vertically, but columns that don't fit scroll sideways inside the
	// table rather than being clipped by the page column's overflowX: hidden.
	databoardBodyOverride: {
		height: 'auto',
		overflowX: 'auto',
		overflowY: 'visible',
	},
	actionRow: {
		display: 'flex',
		gap: spacing.sm,
		alignItems: 'center',
		justifyContent: 'flex-end',
		marginTop: 12,
		marginBottom: 10,
	},
	// Force the chips input onto its own row so the dropdown stays left-aligned
	chipsInputFullRow: {
		flex: 'none',
		width: '100%',
		marginTop: 4,
	},
});
